import React, { Component } from 'react';

import ReactLoading from 'react-loading';

class AgentList extends Component {
  state = { 

  }
  render() {
    return (
      <div className="agent-list">
        <div className="loading-icon-wrapper">
          <ReactLoading type={"spinningBubbles"} color="gray" />
        </div>
      </div>
    );
  }
}

export default AgentList;